/**
 * Call state utilities
 * Pure functions for resolving call state transitions.
 */

import type { CallSession } from 'Modules/softphone/types';

/**
 * Resolves the next current call ID when the active call is removed.
 * Promotes the longest-held call among remaining calls, or returns null
 * if no held calls remain.
 */
export function resolveNextCurrentCallId(
  remainingCalls: Map<string, CallSession>
): string | null {
  const heldCalls = Array.from(remainingCalls.values())
    .filter((c) => c.isOnHold)
    .sort((a, b) => b.duration - a.duration);

  return heldCalls.length > 0 ? heldCalls[0].id : null;
}
